import Common from '@/libs/common';

// Per device, all networks: the bookmark gesture is the same whatever the network.
const SEEN_KEY = 'info.favoritesOnboardingSeen';

/**
 * Whether the "add favorites" onboarding sheet must open, decided once per device.
 *
 * Whatever the answer, the device is stamped as seen right away — before the
 * sheet is even rendered — so a passenger who kills the app on the sheet, or
 * who already knows the gesture (has favorites), never gets it a second time.
 * A storage failure (private browsing, cleared data) only makes the sheet
 * come back next time.
 */
export function shouldShowFavoritesOnboarding(hasFavorites: boolean): boolean {
  if (Common.safeLSParse(SEEN_KEY) === true) return false;
  try {
    localStorage.setItem(SEEN_KEY, JSON.stringify(true));
  } catch {
    // Accepted: the sheet shows again on the next first visit.
  }
  return !hasFavorites;
}
